import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { filterLocationUrl } from '../../Config/config';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { UserContext } from '../../Contexts/UserContext';
import AcquirerTypeFilter from '../RefineSearchComponents/AcquirerTypeFilter';
import CityFilter from '../RefineSearchComponents/CityFilter';
import CountryFilter from '../RefineSearchComponents/CountryFilter';
import AcqIndustryFilter from '../RefineSearchComponents/AcquirerIndustry';
import RegionFilter from '../RefineSearchComponents/RegionFilter';
import StateFilter from '../RefineSearchComponents/StateFilter';
import { TableDataContext } from '../../Contexts/TableDataContext';
import { IoMdArrowDropdown } from "react-icons/io";
 
function MostActiveAcquirersRefineSearch({ customPathname }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { setrefineSearchFilters, onErrorHandler, refineSearchFilters, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(0);

    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    const [AcqIndustriesOptions, setAcqIndustriesOptions] = useState([])
    const [AcquirerCountryOptions, setAcquirerCountryOptions] = useState([])
    const [AcquirerRegionOptions, setAcquirerRegionOptions] = useState([])
    const [AcquirerStateOptions, setAcquirerStateOptions] = useState([])
    const [AcquirerCityOptions, setAcquirerCityOptions] = useState([])
    const [AcquirerTypeOptions, setAcquirerTypeOptions] = useState([])

    const applyFilter = () => {
        const selectedAcqIndustries = AcqIndustriesOptions.filter(industry => industry.isChecked);
        const selectedAcquirerType = AcquirerTypeOptions?.filter(option => option.isChecked);
        const selectedAcquirerCountries = AcquirerCountryOptions?.filter(option => option.isChecked);
        const selectedAcquirerRegion = AcquirerRegionOptions?.filter(option => option.isChecked);
        const selectedAcquirerState = AcquirerStateOptions?.filter(option => option.isChecked);
        const selectedAcquirerCity = AcquirerCityOptions?.filter(option => option.isChecked);

        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                acquirer_industry: selectedAcqIndustries,
                acquirerType: selectedAcquirerType,
                acquirerCountries: selectedAcquirerCountries,
                acquirerRegion: selectedAcquirerRegion,
                acquirerState: selectedAcquirerState,
                acquirerCity: selectedAcquirerCity,
            },
        }))
    }

    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
    }

    // Submitting Refine Search Form 
    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[]}
        }))
        setCurrentPage(1);
        applyFilter();
        setSelected(0)
        if (location.pathname !== customPathname) {
            navigate(customPathname)
        }
    }

    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname !== customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onCountryChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setAcquirerRegionOptions(response.data?.region)
                setAcquirerStateOptions(response.data.state)
                setAcquirerCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }
    
    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = AcquirerCountryOptions?.filter(option => option.isChecked)?.map(option => option.id)
        
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setAcquirerStateOptions(response.data.state)
                setAcquirerCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = AcquirerCountryOptions?.filter(option => option.isChecked)?.map(option => option.id)
        const selectedRegion = AcquirerRegionOptions?.filter(option => option.isChecked)?.map(option => option.id);

        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setAcquirerCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    useEffect(() => {
        const acquirerCountryIds = refineSearchFilters[customPathname]?.acquirerCountries?.map(value => value.id) ?? [];
        const acquirerRegionIds = refineSearchFilters[customPathname]?.acquirerRegion?.map(value => value.id) ?? [];
        const acquirerStateIds = refineSearchFilters[customPathname]?.acquirerState?.map(value => value.id) ?? [];
        const acquirerCityIds = refineSearchFilters[customPathname]?.acquirerCity?.map(value => value.id) ?? [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setAcquirerCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: acquirerCountryIds.includes(option.id) })))
                setAcquirerRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: acquirerRegionIds.includes(option.id) })))
                setAcquirerStateOptions(response.data.state?.map(option => ({ ...option, isChecked: acquirerStateIds.includes(option.id) })))
                setAcquirerCityOptions(response.data.city?.map(option => ({ ...option, isChecked: acquirerCityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters, customPathname, getToken, onErrorHandler])

    const getAcquirerFiltersCount = () => {
        let count = 0;
        if (AcqIndustriesOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerTypeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerCountryOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerRegionOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerStateOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerCityOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

console.log("Most Active Acquirers Refine Search")
    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="grid grid-cols-8 gap-4 h-full">
                            {/* Left column - Section Headers */}
                            <div className="h-full col-span-2 flex flex-col gap-2 border-r border-gray-300 pr-4">

                                {/* Acquirer Section */}
                                <div className="cursor-pointer p-3 rounded-lg bg-[#BC8B20] text-white">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <span className="font-medium">Acquirer</span>
                                            {getAcquirerFiltersCount() > 0 && (
                                                <span className="text-xs rounded-full px-2 py-1 min-w-[20px] text-center bg-white text-[#bc8b20]">
                                                    {getAcquirerFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        <IoMdArrowDropdown />
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="h-full col-span-6 overflow-y-auto">

                                {/* Acquirer Content */}
                                <div className="grid grid-cols-2 gap-x-6 gap-y-8">
                                    <AcqIndustryFilter
                                            IndustriesOptions={AcqIndustriesOptions}
                                            setIndustriesOptions={setAcqIndustriesOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(29)}
                                            label="Acquirer Industry"
                                            open={select === 29}
                                            isPopupOpen={openFilterPopup === 'acquirerIndustry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerIndustry' : null)}
                                        />
                                        <AcquirerTypeFilter
                                            AcquirerTypeOptions={AcquirerTypeOptions}
                                            setAcquirerTypeOptions={setAcquirerTypeOptions}
                                            customPathname={customPathname}
                                            label="Acquirer Company Type"
                                            accordionClick={() => accordionClick(7)}
                                            open={select === 7}
                                            isPopupOpen={openFilterPopup === 'acquirerType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerType' : null)}
                                        />
                                        <CountryFilter
                                            CountryOptions={AcquirerCountryOptions}
                                            setCountryOptions={setAcquirerCountryOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(8)}
                                            onChange={(options) => onCountryChange(options)}
                                            filterPathkey="acquirerCountries"
                                            label='Acquirer Country'
                                            open={select === 8}
                                            isPopupOpen={openFilterPopup === 'acquirerCountry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerCountry' : null)}
                                        />
                                        <RegionFilter
                                            RegionOptions={AcquirerRegionOptions}
                                            setRegionOptions={setAcquirerRegionOptions}
                                            customPathname={customPathname}
                                            filterPathkey="acquirerRegion"
                                            label='Acquirer Region'
                                            accordionClick={() => accordionClick(9)}
                                            onChange={(options) => onRegionChange(options)}
                                            open={select === 9}
                                            isPopupOpen={openFilterPopup === 'acquirerRegion'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerRegion' : null)}
                                        />
                                        <StateFilter
                                            StateOptions={AcquirerStateOptions}
                                            setStateOptions={setAcquirerStateOptions}
                                            customPathname={customPathname}
                                            onChange={(options) => onStateChange(options)}
                                            filterPathkey="acquirerState"
                                            label='Acquirer State'
                                            accordionClick={() => accordionClick(10)}
                                            open={select === 10}
                                            isPopupOpen={openFilterPopup === 'acquirerState'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerState' : null)}
                                        />
                                        <CityFilter
                                            CityOptions={AcquirerCityOptions}
                                            setCityOptions={setAcquirerCityOptions}
                                            filterPathkey="acquirerCity"
                                            label='Acquirer City'
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(11)}
                                            open={select === 11}
                                            isPopupOpen={openFilterPopup === 'acquirerCity'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerCity' : null)}
                                        />
                                    </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    )
}

export default MostActiveAcquirersRefineSearch